<template>
  <v-container v-if="orders" fluid>

    <im-page-title
      title="Listă Rezervări"
    />

    <im-orders-toolbar
      :query.sync="query"
    />

    <div class="ma-3">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-orders-list
      :orders="orders"
      :pagination.sync="pagination"
      @edit="goToOrder($event)"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import _ from 'lodash';
  import repository from '@/repositories/order-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-orders-toolbar': () => import('@/components/Order/OrderToolbar'),
      'im-orders-list': () => import('@/components/Order/OrderList')
    },

    data: () => ({
      orders: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    async created() {
      await this.fetchOrders();
    },

    watch: {
      query: {
        handler: 'fetchOrdersDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchOrders',
        immediate: false
      }
    },

    methods: {

      fetchOrdersDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchOrders()
      }, 300),

      async fetchOrders() {
        this.querying = true;
        this.orders = await repository.getOrders(this.query, this.pagination);
        this.querying = false;
      },

      goToOrder(order) {
        this.$router.push({path: `/orders/${order.id}`})
      },

    }

  }

</script>